import { render, staticRenderFns } from "./Datadict.vue?vue&type=template&id=651aba32&scoped=true"
import script from "./Datadict.vue?vue&type=script&lang=js"
export * from "./Datadict.vue?vue&type=script&lang=js"
import style0 from "./Datadict.vue?vue&type=style&index=0&id=651aba32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651aba32",
  null
  
)

export default component.exports